function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as c } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: s , size: e = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = c(), o = s !== null && s !== void 0 ? s : a ? l.colors.inverse : l.colors.neutralHigh, { skinName: n  } = h();
    return n.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ t("path", {
                fill: o,
                d: "M11.998 2C6.488 2 2 6.488 2 12s4.487 10 9.998 10a9.97 9.97 0 005.33-1.544.353.353 0 00.113-.496.36.36 0 00-.496-.112 9.257 9.257 0 01-4.951 1.432c-5.119 0-9.282-4.164-9.282-9.284 0-5.12 4.167-9.288 9.286-9.288s9.282 4.164 9.282 9.284a9.261 9.261 0 01-1.432 4.952.36.36 0 00.608.384A9.965 9.965 0 0022 11.996C21.996 6.488 17.513 2 11.998 2z"
            }),
            /* @__PURE__ */ t("path", {
                fill: o,
                d: "M10.928 16l-3.834-4.267a.336.336 0 010-.467.292.292 0 01.44 0l3.394 3.732L17.466 8.1a.292.292 0 01.44 0 .336.336 0 010 .466L10.928 16zm7.861 3.504a.716.716 0 100-1.432.716.716 0 000 1.432z"
            })
        ]
    })) : /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ t("path", {
                fill: o,
                d: "M10.107 16.73a.29.29 0 00.235.116c.09 0 .178-.044.235-.116l6.864-8.872a.298.298 0 00-.053-.416.298.298 0 00-.417.053l-6.63 8.565-2.652-3.466a.296.296 0 00-.416-.057.296.296 0 00-.057.417l2.89 3.776z"
            }),
            /* @__PURE__ */ t("path", {
                fill: o,
                d: "M11.998 23C4.805 23 1 19.198 1 12.002 1 4.805 4.802 1 11.998 1c3.511 0 6.232.908 8.093 2.703C22.02 5.563 23 8.356 23 12.002 23.003 19.195 19.198 23 11.998 23zm0-21.374c-6.88 0-10.372 3.492-10.372 10.376 0 6.88 3.489 10.372 10.372 10.372 6.887 0 10.376-3.489 10.376-10.372.003-6.887-3.489-10.376-10.376-10.376z"
            })
        ]
    }));
}, g = m;
export { g as default };
